import TenantId from '../tenant';
import geollectTheme from './geollect';

const ThemeConfig = {
  [TenantId.GEOLLECT]: geollectTheme,
};

export default ThemeConfig;
